// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3fn4i","logo":"header_logo__14tHM","profilePhone":"header_profilePhone__W3lUM","hamburgerSection":"header_hamburgerSection__19DEn"};